// Deps
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

/**
 * Video Carousel Slider
 * ------------------------------------------------------- *
 */
// eslint-disable-next-line camelcase
const video_carousel = ( function( document ) {
	const _instance = {};
	var options = {
		loop: true,
		autoplay: {
			delay: 3000
		},
		disableOnInteraction: true,
		spaceBetween: 0,
		loopFillGroupWithBlank: true,
		slidesPerView: 1,
		breakpoints: {
			1025: {
				slidesPerView: 3,
				spaceBetween: 30
			}
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev'
		}
	};

	var selector = '.video-carousel';
	var element = false;
	var swiper;

	Swiper.use([ Navigation, Pagination, Autoplay ]);

	function init() {
		var count;
		element = document.querySelector( selector );

		if ( ! element ) {
			return;
		}

		count = element.querySelectorAll(  '.swiper-container .swiper-slide' ).length;

		if ( 1 === count ) {
			element.classList.add( 'disabled' );
		}

		swiper = new Swiper( selector, options );

		element.addEventListener( 'mouseenter', function( event ) {
			swiper.autoplay.stop();
		}, false );

		element.addEventListener( 'mouseleave', function( event ) {
			swiper.autoplay.start();
		}, false );
	}

	/**
	* Public
	*/
	_instance.init = function() {
		init();
	};

	return _instance;
}( document ) );

// eslint-disable-next-line camelcase
export default video_carousel;
